import http from "./http";

/* ================= GET ALL ================= */
export const getClasses = async () => {
  try {
    const res = await http.post("manage_class?action=get");
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= ADD ================= */
export const addClass = async (data) => {
  try {
    const formData = new FormData();

    formData.append("class_name", data.class_name);

    // ✅ backend required
    formData.append("teacher_ids", "null");

    const res = await http.post("manage_class?action=add", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= UPDATE ================= */
export const updateClass = async (id, data) => {
  try {
    const formData = new FormData();

    formData.append("id", id);
    formData.append("class_name", data.class_name);

    // ✅ required
    formData.append("teacher_ids", "null");

    const res = await http.post("manage_class?action=update", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= DELETE ================= */
export const deleteClass = async (id) => {
  try {
    const res = await http.post(`manage_class?action=delete&id=${id}`);
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};